import React from 'react';
import SelectSocialProfiles from '../selectSocialProfiles/SelectSocialProfiles';
import Modal from 'components/shared/Modal';
import { Button } from '@kontentino/ui';
import PageTypeUtils from 'app/utils/pageType';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { useTranslation } from 'react-i18next';
import { NewAddedPage } from 'types/Page';
import { SocialLoginPage, SocialLoginTokenType } from 'types/SocialLogin';
import { ApiClientError } from 'api/client';
import useSocialProfilesSelection from './useSocialProfilesSelection';

interface Props {
  data: SocialLoginPage[];
  onPagesCreate: (page: NewAddedPage) => void;
  isSingleSelect?: boolean;
  isPartial?: boolean;
  connectedPagesExternalIds: string[];
  page: {
    type: number;
    // Reconnect target. `addProfiles` has no page-id parameter — the backend
    // matches on `external_id` — so this is threaded to the boundary but not
    // sent. Remove it only once the API question is settled either way.
    id?: number;
  };
  onError?: (error: ApiClientError) => void;
  clientBusinessId?: string | null;
  tokenType?: SocialLoginTokenType;
  userKey?: string | null;
}

const GenericProfilesSelectForm = ({
  data,
  onPagesCreate,
  connectedPagesExternalIds,
  isSingleSelect,
  isPartial,
  page,
  onError,
  clientBusinessId,
  tokenType,
  userKey,
}: Props) => {
  const { t } = useTranslation();
  const selection = useSocialProfilesSelection({
    data,
    pageType: page.type,
    connectedPagesExternalIds,
    onPagesCreate,
    onError,
    isSingleSelect,
    clientBusinessId,
    tokenType,
    userKey,
  });

  return (
    <div>
      <SelectSocialProfiles
        profiles={selection.profiles}
        selectedIds={selection.selectedProfiles}
        isPartial={isPartial}
        onSelect={(id) => selection.handleSelect(id as string)}
        onSelectAll={selection.handleSelectAll}
        onSelectNone={selection.handleSelectNone}
      />
      <Modal.Footer className="tw-px-0">
        <Button
          disabled={selection.selectedProfiles.length === 0}
          isLoading={selection.isSubmitting}
          onClick={selection.handleSubmit}
          data-name={`posts_add-profile-modal_${PageTypeUtils.getName(
            TYPE.FACEBOOK,
          )}_confirm`}
          className="tw-w-full"
        >
          {t('addProfile')}
        </Button>
      </Modal.Footer>
    </div>
  );
};

export default GenericProfilesSelectForm;
